<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title
          v-if="commenting"
          class="headline grey lighten-2"
          primary-title
          >{{ $t("operation_comment_dialog.enter_comment") }}</v-card-title
        >
        <v-card-title v-else class="headline grey lighten-2" primary-title>{{
          $t("operation_comment_dialog.return_to_center")
        }}</v-card-title>
        <div class="workcenter-select">
          <v-select
            v-if="!commenting"
            v-model="selectedWorkCenter"
            :items="workCenters"
            :label="$t('operation_comment_dialog.return_to')"
          ></v-select>
        </div>

        <v-card-text>
          <v-textarea
            id="comment-input"
            autofocus
            v-model="comment"
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="commenting && !loading"
            color="primary"
            flat
            @click="saveComment"
            >{{ $t("operation_comment_dialog.okay") }}</v-btn
          >
          <v-btn
            v-if="!commenting && !loading"
            :disabled="returnDisabled"
            color="primary"
            flat
            @click="saveReturn"
            >{{ $t("operation_comment_dialog.okay") }}</v-btn
          >
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn color="primary" flat @click="dialog = false">{{
            $t("operation_comment_dialog.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Product from "@/models/Product.js";
import WorkCenter from "@/models/WorkCenter.js";
import Comment from "@/models/Comment.js";
export default {
  props: ["workCenterId"],
  data() {
    return {
      loading: false,
      selectedWorkCenter: null,
      dialog: false,
      workCenters: [],
      comment: "",
      commenting: true,
      products: [],
      centers: [],
      onKeyUp: (e) => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },
  computed: {
    returnDisabled(){
      if(this.selectedWorkCenter == null) return true;
      if(this.comment == null || this.comment.trim().length == 0)return true;
      return false;
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.selectedWorkCenter = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },

  async created() {
    this.centers = await WorkCenter.loadCenters();
    this.getWorkCenters();
  },

  methods: {
    getWorkCenters() {
      const currentCenter = this.centers.find((workCenter) => {
        return workCenter.id == this.$route.params.id;
      });
      this.workCenters = this.centers.filter((workCenter) => {
        return workCenter.code < currentCenter.code;
      });
    },

    async openComment(products) {
      this.getWorkCenters();
      this.products = products;
      this.commenting = true;
      this.comment = "";
      this.dialog = true;
    },

    openReturn(products) {
      this.getWorkCenters();
      this.products = products;
      this.commenting = false;
      this.comment = "";
      this.dialog = true;
    },

    async saveComment() {
      await Product.recordProblem(
        this.$route.params.id,
        this.products,
        this.comment
      );
      this.dialog = false;
      this.$emit("commentWritten");
    },

    async saveReturn() {
      if (!this.selectedWorkCenter) {
        alert(this.$t("operation_comment_dialog.please_select_work_center"));
        return;
      }
      this.loading = true;
      const operation = this.products[0].getWorkCenterOperation(
        this.workCenterId
      );
      console.log(operation);
      const comment = {
        text: this.comment,
        table_name: "product_operations",
        table_id: operation.id,
      };
      await Comment.create(comment);
      await Product.returnOperations(
        this.$route.params.id,
        this.products,
        this.selectedWorkCenter
      );
      this.dialog = false;
      this.loading = false;
      this.$emit("operationsReturned");
    },
  },
};
</script>

<style scoped>
.workcenter-select {
  position: relative;
  left: 25px;
  width: calc(100% - 50px);
  height: 50px;
}
</style>